"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPApiProvider = void 0;
const handleAxiosClientRequest_1 = __importDefault(require("../client/axios/handleAxiosClientRequest"));
const ApiProvider_1 = require("./ApiProvider");
class HTTPApiProvider extends ApiProvider_1.ApiProvider {
    async request(options) {
        const clientOptions = { ...options };
        if (this._api) {
            clientOptions.url = this._api;
        }
        const response = await (0, handleAxiosClientRequest_1.default)(clientOptions);
        return response;
    }
}
exports.HTTPApiProvider = HTTPApiProvider;
//# sourceMappingURL=HTTPApiProvider.js.map